import { Heading, HeadingProps } from '@chakra-ui/react';

export const SubHeading = (props: HeadingProps) => {
  const { children, mb = 3, as = 'h2' } = props;

  return (
    <Heading as={as} mb={mb} fontSize="lg" fontWeight="medium" lineHeight={6} flexGrow="1" {...props}>
      {children}
    </Heading>
  );
};
